<template>
    <div class="pb50">
        <div>
            <el-button size="small" icon="el-icon-plus" @click="addRelation()">选择关联商品</el-button>
        </div>
        <el-table size="small" :data="list" style="width: 100%" v-loading="loading">

            <el-table-column prop="relation_goods_id" label="关联商品ID" width="70"></el-table-column>
            <el-table-column prop="goods.goods_name" label="商品名称"></el-table-column>

            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="deleteRelation(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--商品选择-->
        <Goods :isgoods="isgoods" :exclude-ids="exclude_ids" :islist="false" @closeDialog="closeGoodsFunc"></Goods>
    </div>
</template>
<script>
    import GoodsApi from "@/api/goods.js";
    import Goods from "@/components/goods/Goods";
    export default {
        components: {
            Goods
        },
        data () {
            return {
                goods_id: '',
                list: [],
                /*是否加载完成*/
                loading: false,
                /*是否打开选择商品*/
                isgoods: false,
                /*已有的id*/
                exclude_ids: [],
                form: {
                    goods_id   : '',
                    relation_goods_id  : '',
                },
            };
        },
        created() {
            this.goods_id = this.$route.query.goods_id;
            this.form.goods_id = this.$route.query.goods_id;
            this.getData();
        },
        methods: {
            couponNumChange(e, row){
                this.form = row;
                this.form.coupon_num = e;
                this.onSubmit();
            },
            /*添加优惠券*/
            addRelation() {
                this.isgoods = true;
            },
            /*关闭商品选择*/
            closeGoodsFunc(e) {
                this.isgoods = false;
                if (e.type == "success") {
                    this.form = {};
                    this.form.goods_id = this.$route.query.goods_id;
                    this.form.relation_goods_id = e.params.goods_id;
                    this.onSubmit();
                }
            },
            /*关闭弹窗*/
            closeGoodsDialogFunc(e) {
                this.open_add = e.openDialog;
                if (e.type == "success") {
                }
            },
            /*获取数据*/
            getData() {
                let self = this;
                this.loading = true;
                GoodsApi.getRelation({goods_id:this.goods_id})
                    .then((res) => {
                        self.loading = false;
                        self.list = res.data.list;

                        let exclude_ids = [];
                        self.list.forEach((item) => {
                            exclude_ids.push(item.relation_goods_id);
                        });
                        self.exclude_ids = exclude_ids;
                    })
                    .catch((error) => {});
            },

            /*修改*/
            onSubmit () {
                let self = this
                let params = this.form
                self.loading = true
                GoodsApi.editRelation(params, true)
                    .then((res) => {
                        self.loading = false
                        self.$message.success(res.msg)
                        self.getData()
                    })
                    .catch((error) => {
                        self.loading = false
                    })
            },
            /*删除关联商品*/
            deleteRelation (row) {
                let self = this
                self.$confirm('确定删除该关联商品?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText : '取消',
                    type             : 'warning'
                }).then(() => {
                    self.loading = true
                    GoodsApi.delRelation({ relation_id: row.relation_id }, true).then((data) => {
                        self.loading = false
                        self.$message({
                            message: data.msg,
                            type   : 'success'
                        })
                        self.getData()
                    })
                })
            },

        }
    };
</script>

<style>
    .reward-list .reward-item {
        margin-bottom: 10px;
        padding: 10px 20px;
        border: 1px solid #ebeef5;
    }

    .reward-list .delete-reward {
        position: absolute;
        top: 10px;
        right: 20px;
        cursor: pointer;
        z-index: 10;
    }
</style>



// WEBPACK FOOTER //
// src/views/goods/goods/relation.vue